import { FormControl, InputGroup, Modal, ModalBody } from 'react-bootstrap'
import { textApplyVariables, useText } from '../../context/TextContext'
import CloseButton from '../CloseButton'
import { toast } from 'react-toastify'
import { createShareTokenLink } from '../../utils/shared/links'
import { AdvancedButton } from '../AdvancedButton'
import { Invoice } from '../../models/shared/Invoice'
import { useOrganization } from '../../context/OrganizationContext'
import { Customer } from '../../models/shared/Customer'
import { createSmsLink, isMobileDevice } from '../../utils/logic'

interface Props {
    customer: Customer | null,
    invoice: Invoice | null,
    onHide: () => void
}

export default function InvoiceShareModal(props: Props) {
    const text = useText();
    const { organization } = useOrganization();

    const link = createShareTokenLink(props.invoice?.shareTokenId || '', { invoice: true });

    const mailtoLink = `mailto:?to=${encodeURIComponent(props.customer?.email || '')}`
        + `&subject=${encodeURIComponent(textApplyVariables(text.shareInvoiceMailtoSubject, { organizationName: organization?.name || '' }))}`
        + `&body=${encodeURIComponent(textApplyVariables(text.shareInvoiceMailto, { link, organizationName: organization?.name || '', customerName: props.customer?.name || '' }))}`;

    const isMobile = isMobileDevice();
    const smsLink = createSmsLink(props.customer?.phone || '',
        textApplyVariables(text.shareInvoiceSms, { link, organizationName: organization?.name || '', customerName: props.customer?.name || '' }));

    const handleCopy = () => {
        navigator.clipboard.writeText(link)
        toast.success(text.linkCoppied);
    }

    return (
        <Modal show={!!props.invoice} onHide={props.onHide}>
            <ModalBody className='d-flex flex-column gap-3'>
                <div className='d-flex justify-content-between align-items-start'>
                    <div>
                        <Modal.Title>{text.sendInvoice}</Modal.Title>
                        <p className='text-muted small m-0'>{text.sendInvoiceDescription}</p>
                    </div>
                    <CloseButton onClick={props.onHide} />
                </div>

                <div className='d-flex flex-column gap-3'>
                    <InputGroup>
                        <FormControl
                            value={link}
                            readOnly
                            onFocus={(e) => e.target.select()}
                            onClick={(e: any) => e.target.select()}
                        />
                        <AdvancedButton icon="bi-copy" variant='outline-primary' onClick={handleCopy} />
                    </InputGroup>

                    <div className='d-flex flex-column align-items-start gap-2'>
                        <AdvancedButton variant='secondary' icon='bi-envelope' link={mailtoLink}>{text.sendEmail}</AdvancedButton>
                        <AdvancedButton variant='secondary' disabled={!isMobile} href={isMobile ? smsLink : undefined} icon='bi-phone'>{text.sendSMS}</AdvancedButton>
                    </div>
                </div>

                <div className='d-flex justify-content-end'>
                    <button className='btn btn-secondary' onClick={props.onHide}>
                        {text.close}
                    </button>
                </div>
            </ModalBody>
        </Modal>
    )
}
